import { render, staticRenderFns } from "./ModelSelectBrands.vue?vue&type=template&id=3c74088d&scoped=true&"
import script from "./ModelSelectBrands.vue?vue&type=script&lang=js&"
export * from "./ModelSelectBrands.vue?vue&type=script&lang=js&"
import style0 from "./ModelSelectBrands.vue?vue&type=style&index=0&id=3c74088d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c74088d",
  null
  
)

export default component.exports